var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { AonDialog } from "../../components/core/AonDialog";
import { handleClientAddOperation } from "../../api/marketData/AllStaffCrud";
import { UuiFlexlayout, UuiInputTitle, UuiLogo } from "@aonunited/react";
;
import { AonButton } from "../../components/core/AonButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { BUTTON_VARIANT } from "../../components/core/AonButton/consts";
import { useAppInfoStore, useClientPageStore, useErrorStore, useNotificationStore } from "../../store";
import "./clientStaffDailog.scss";
import { AonInput } from "../../components/core/AonInput";
import { useNavigate } from "react-router-dom";
export var ClientStaffAddDailog = function (props) {
    var AddDailogBody = function () {
        var _a = useState(""), errorMsg = _a[0], setErrorMsg = _a[1];
        var _b = useState(false), apiLoading = _b[0], setApiLoading = _b[1];
        var navigation = useNavigate();
        var errorStore = useErrorStore();
        var _c = useState({
            name: "",
            email: "",
            additionalInfo: ""
        }), form = _c[0], setForm = _c[1];
        var clientStore = useClientPageStore();
        var appInfo = useAppInfoStore();
        var notificationStore = useNotificationStore();
        var onClickAdd = function () { return __awaiter(void 0, void 0, void 0, function () {
            var clientDetails, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (!form.email || !form.name) {
                            handledErrorMsg("Email and Name are required fields");
                            return [2 /*return*/];
                        }
                        setApiLoading(true);
                        clientDetails = clientStore.selectedClientDetails;
                        return [4 /*yield*/, handleClientAddOperation({
                                "requestType": "NEA", //Hard Coaded for add client
                                "clientName": clientDetails.name,
                                "clientGuid": props.clientGuid,
                                "clientId": clientDetails.code,
                                "requestorAdditionalinfo": form.additionalInfo,
                                externalEmails: form.email,
                                externalUser: form.name
                                // "requestorName": userInfo.displayName,
                                //"requestorEmail": requestorEmail,
                                //"oktaID":oktaID,
                                //"externalAccounts": [
                                //  {
                                //    "name": form.name,
                                //  "email": form.email
                                //  }
                                // ]
                            })];
                    case 1:
                        _a.sent();
                        notificationStore.showNotification({ message: "Request Submitted successfully", variant: "success", visible: true });
                        props.onClickClose();
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        notificationStore.showNotification({ message: "Something went wrong! Please try again", variant: "error", visible: true });
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                        console.log(err_1);
                        setApiLoading(false);
                        return [3 /*break*/, 4];
                    case 3:
                        setApiLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var handledErrorMsg = function (msg) {
            setErrorMsg(msg);
            var timoutInstance = setTimeout(function () {
                setErrorMsg("");
                clearTimeout(timoutInstance);
            }, 3000);
        };
        var saveForm = function (name, value) {
            setForm(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
            });
        };
        return React.createElement("div", null,
            React.createElement("h3", { style: { marginTop: "0px", marginBottom: "8px" } }, "Add Client Staff"),
            React.createElement(UuiFlexlayout, { style: { marginBlock: "10px" }, direction: 'row', gap: 'xs' },
                React.createElement("div", { style: { width: "100%" } },
                    React.createElement(AonInput, { label: "First and Last Name:", required: true, "aria-label": "Outlined", disabled: apiLoading, id: "__AddSearchId__", onTextChange: function (event) { return saveForm("name", event.target.value); }, value: form.name, type: "text" }))),
            React.createElement(UuiFlexlayout, { style: { marginBlock: "10px" }, direction: 'row', gap: 'xs' },
                React.createElement("div", { style: { width: "100%" } },
                    React.createElement(AonInput, { label: 'Email Address:', required: true, disabled: apiLoading, onTextChange: function (event) { return saveForm("email", event.target.value); }, value: form.email, type: "text" }))),
            React.createElement(UuiFlexlayout, { style: { marginBlock: "10px" }, direction: 'row', gap: 'xs' },
                React.createElement("div", { style: { width: "100%" } },
                    React.createElement(UuiInputTitle, null, "Additional Information (Optional):"),
                    React.createElement("textarea", { rows: 6, cols: 72, style: { width: "100%", borderRadius: "5px", borderWidth: "1px", borderColor: "grey" }, disabled: apiLoading, onChange: function (event) { return saveForm("additionalInfo", event.target.value); }, value: form.additionalInfo, placeholder: 'Any other information that will help the Market Security team approve this request...' }),
                    apiLoading && React.createElement("div", null, "Loading..."))),
            React.createElement("div", { style: { fontSize: "18", color: "red", marginBlock: "18" } }, errorMsg ? React.createElement("span", null, errorMsg) : null),
            React.createElement("div", { style: { paddingBlock: "10px" } },
                React.createElement(AonButton, { disabled: apiLoading, style: { marginInline: "10px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: function () {
                        onClickAdd();
                    } }, "Submit"),
                React.createElement(AonButton, { disabled: apiLoading, style: { marginInline: "10px" }, variant: BUTTON_VARIANT.PROMINENT, onClick: function () {
                        props.onClickClose();
                    } }, "Close")));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(AonDialog, { dismissOnEsc: false, dismissOnOverlay: false, opened: props.showDailog, enableBackgroundScroll: false, header: React.createElement("div", { className: 'header' },
                React.createElement("div", { className: 'logo_about_dialog' },
                    React.createElement(UuiLogo, { onClick: function () { } })),
                React.createElement(FontAwesomeIcon, { className: 'text-icon', onClick: props.onClickClose, icon: faClose })), body: React.createElement(AddDailogBody, null) })));
};
